module.exports = __webpack_public_path__ + "img/shop.6a64446.png";